<template>
    <div class="gateway-container">
        <div class="home-banner" v-if="isHomePage">
            <div class="container">
                <el-image :src="require('@/assets/indexPage/home/home-logo.png')" />
            </div>
        </div>

        <NavBarCommon ref="navBarCommonRef" :isLogin="isLogin" :userName="userName" v-show="navbarShow" :class="navbarClass" @handleCommand="handleCommand" />

        <router-view ref="routerViewRef" />

        <!-- 登录 -->
        <transition name="el-fade-in-linear">
            <div class="login-box" v-if="loginBox">
                <div class="login-box-pop">
                    <i class="close" @click=" loginBox = false; whereLogin = 1;"></i>
                    <ul class="user-list">
                        <li :class="loginForm['userType'] == '4' ? 'active user-list-QY' : 'user-list-QY'"
                            @click="switchLoginType('4')">
                            <i class="user-icon"></i> <span>个人/企业登录</span>
                        </li>
                        <li :class="loginForm['userType'] == '1' ? 'active user-list-JR' : 'user-list-JR'"
                            @click="switchLoginType('1')">
                            <i class="user-icon"></i> <span>金融机构登录</span>
                        </li>
                        <li :class="loginForm['userType'] == '3' ? 'active user-list-ZF' : 'user-list-ZF'"
                            @click="switchLoginType('3')">
                            <i class="user-icon"></i> <span>政府部门登录</span>
                        </li>
                        <li :class="loginForm['userType'] == '5' ? 'active user-list-ZF' : 'user-list-ZF'"
                            @click="switchLoginType('5')">
                            <i class="user-icon"></i> <span>农交中心登录</span>
                        </li>
                        <li :class="loginForm['userType'] == '2' ? 'active user-list-QT' : 'user-list-QT'"
                            @click="switchLoginType('2')">
                            <i class="user-icon"></i> <span>其他机构登录</span>
                        </li>
                    </ul>
                    <div class="login-form">
                        <el-card class="box-card">
                            <div class="form-paww">
                                <el-form :model="loginForm" :rules="loginRules" ref="loginFormRef" label-width="0">
                                    <el-form-item label="" prop="username">
                                        <el-input v-model="loginForm.username" placeholder="手机号"></el-input>
                                    </el-form-item>
                                    <el-form-item label="" prop="password">
                                        <el-input v-model="loginForm.password" show-password placeholder="密码"></el-input>
                                    </el-form-item>
                                    <el-form-item label="" prop="verificationCode">
                                        <el-row :gutter="20">
                                            <el-col :span="16">
                                                <el-input v-model="loginForm.verificationCode" placeholder="验证码"
                                                    @keydown.enter.native="onSubmit"></el-input>
                                            </el-col>
                                            <el-col :span="8" style="height: 40px;">
                                                <img :src="verificationCodeUrl" alt
                                                    @click="switchLoginType(loginForm['userType'])"
                                                    style="width: 100%; height: 40px" />
                                            </el-col>
                                        </el-row>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" @click="onSubmit" style="width: 100%">登录</el-button>
                                        <div style="min-height: 40px">
                                            <el-row>
                                                <el-col :span="12"><el-button type="text"
                                                        @click="modifyPassword">忘记密码?</el-button></el-col>
                                                <el-col :span="12" v-if="loginForm['userType'] === '4'"><el-button
                                                        type="text" @click="registerAccont"
                                                        style="float: right">注册账户</el-button></el-col>
                                            </el-row>
                                        </div>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </el-card>
                    </div>
                </div>
            </div>
        </transition>

        <!-- 注册账户 -->
        <transition name="el-fade-in-linear">
            <div class="login-box" v-if="dialogProcess">
                <div class="login-box-pop-ZC">
                    <i class="close" @click="dialogProcess = false"></i>
                    <h4 class="registerTitle-ZC">注册账户</h4>
                    <div class="login-form-ZC">
                        <el-card class="box-card">
                            <div class="form-paww-ZC">
                                <el-form :model="accountForm" :rules="accountFormRules" ref="accountForm" label-width="0">
                                    <el-form-item label="" prop="phone">
                                        <el-input v-model.number="accountForm.phone" placeholder="请输入手机号码"
                                            auto-complete="off"></el-input>
                                    </el-form-item>
                                    <el-form-item label="" prop="userType">
                                        <el-select v-model="accountForm.userType" placeholder="请选择类型" class="w-100">
                                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="" prop="password" style="margin-bottom: 28px">
                                        <el-input v-model="accountForm.password" show-password
                                            placeholder="请输入密码"></el-input>
                                    </el-form-item>
                                    <el-form-item label="" prop="confirmPassword">
                                        <el-input v-model="accountForm.confirmPassword" show-password
                                            placeholder="请确认密码"></el-input>
                                    </el-form-item>
                                    <el-form-item label="" prop="phoneMessageCode" class="marginBottom">
                                        <el-input ref="registerVerificationCode" v-model="accountForm.phoneMessageCode"
                                            placeholder="请输入验证码" auto-complete="off">
                                            <template slot="append">
                                                <el-button plain :style="{ color: modifyDisabled ? '#359eff' : '#2578e2' }"
                                                    :disabled="accountDisabled" @click="getAccountCode">{{ accountCodeText
                                                    }}
                                                </el-button>
                                            </template>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <!-- @click.stop.self 阻止事件冒泡，并且只作用在其本身 -->
                                        <el-checkbox v-model="treatyChecked">我已经认真阅读并同意服务平台的
                                            <a href="##" class="rehmannia" @click.stop.self="visitTreaty">《使用协议》</a>
                                        </el-checkbox>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-row :gutter="24">
                                            <el-col :span="12">
                                                <el-button @click="closeProcessForm('accountForm')" style="width: 100%">取消
                                                </el-button>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-button type="primary" @click="submitProcessForm('accountForm')"
                                                    :loading="submitRegisterLoading" style="width: 100%">确定
                                                </el-button>
                                            </el-col>
                                        </el-row>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </el-card>
                    </div>
                </div>
            </div>
        </transition>
        <!-- 注册账户 -->

        <!-- 忘记密码 修改密码 -->
        <transition name="el-fade-in-linear">
            <div class="login-box" v-if="forgetPasswordDialog">
                <div class="login-box-pop">
                    <i class="close" @click="forgetPasswordDialog = false"></i>
                    <h4 class="registerTitle">忘记密码</h4>
                    <div class="login-form">
                        <el-card class="box-card">
                            <div class="form-paww">
                                <el-form :model="modifyForm" :rules="modifyFormRules" status-icon ref="modifyForm"
                                    class="account-ruleForm">
                                    <el-form-item prop="phone">
                                        <el-input v-model.number="modifyForm.phone" placeholder="请输入手机号码"
                                            auto-complete="off"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="password" style="margin-bottom: 28px">
                                        <el-input v-model="modifyForm.password" show-password type="password"
                                            placeholder="请输入新密码" auto-complete="off"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="confirmPassword">
                                        <el-input v-model="modifyForm.confirmPassword" show-password type="password"
                                            placeholder="请确认密码" auto-complete="off"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="phoneMessageCode" class="marginBottom">
                                        <el-input placeholder="请输入验证码" ref="modifyVerificationCode"
                                            v-model="modifyForm.phoneMessageCode" auto-complete="off">
                                            <template slot="append">
                                                <el-button plain :style="{ color: modifyDisabled ? '#359eff' : '#2578e2', fontSize: '14px' }"
                                                    :disabled="modifyDisabled" @click="getModifyCode">
                                                    {{ modifyCodeText }}
                                                </el-button>
                                            </template>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-row :gutter="24">
                                            <el-col :span="12">
                                                <el-button @click="closeModifyForm" style="width: 100%">取消
                                                </el-button>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-button @click="submitModifyForm('modifyForm')" type="primary"
                                                    :loading="submitForgetPasswordLoading" style="width: 100%">确定
                                                </el-button>
                                            </el-col>
                                        </el-row>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </el-card>
                    </div>
                </div>
            </div>
        </transition>

        <FooterCommon ref="commonFooterRef" />
    </div>
</template>

<script>
import http from "@/utils/request";
import api from "@/api/index";
import { isParamEmpty } from '../utils/filters';

import {
    setToken,
    setUserName,
    setRefreshToken,
    setUserType,
    setEnterpriseIsAuth,
    removeToken,
    removeRefreshToken,
    removeUserType,
    removeUserName,
    removeRealName,
    removeEnterpriseIsAuth,
    getUserName,
    getRealName,
} from "@/utils/auth";
import { getToken, getEnterpriseIsAuth, getUserType } from "@/utils/auth";
export default {
    name: 'gatewayContainerVue',
    data() {
        const accountPhone = (rule, value, callback) => {
            if (!value) {
                this.disabledType === "MODIFY"
                    ? (this.modifyDisabled = true)
                    : (this.accountDisabled = true);
                return callback(new Error("手机号码不能为空"));
            } else {
                if (
                    !/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/i.test(
                        value
                    )
                ) {
                    this.disabledType === "MODIFY"
                        ? (this.modifyDisabled = true)
                        : (this.accountDisabled = true);
                    callback(new Error("请输入正确的手机号码"));
                } else {
                    this.disabledType === "MODIFY"
                        ? (this.modifyDisabled = false)
                        : (this.accountDisabled = false);
                    callback();
                }
            }
        };
        const modifyPassword = (rule, value, callback) => {
            if (!value) {
                callback(new Error("密码不能为空"));
            } else if (
                !/(?!^(\d+|[a-zA-Z]+|[`~!@#$%^*()_+?:{},.\/;[\]]+)$)^[\w`~!@#$%^*()_+?:{},.\/;[\]]{8,16}$/.test(value)
            ) {
                callback(new Error("请输入长度为8到16个字符，由大写字母、小写字母、数字和特殊字符任意两种及以上组合的密码"));
            } else {
                callback();
            }
        };
        const modifyCheckPass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.modifyForm.password) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        const accountPassword = (rule, value, callback) => {
            if (!value) {
                callback(new Error("密码不能为空"));
            } else if (
                !/(?!^(\d+|[a-zA-Z]+|[`~!@#$%^*()_+?:{},.\/;[\]]+)$)^[\w`~!@#$%^*()_+?:{},.\/;[\]]{8,16}$/.test(value)
            ) {
                callback(new Error("请输入长度为8到16个字符，由大写字母、小写字母、数字和特殊字符任意两种及以上组合的密码"));
            } else {
                callback();
            }
        };
        const accountCheckPass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.accountForm.password) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            isHomePage: true,
            isLogin: false,
            navbarShow: true,
            userName: '',
            navbarClass: 'invert-navbar other-page-navbar',

            // 登陆相关
            loginBox: false,
            verificationCodeUrl: '',
            loginForm: {
                uuid: '',
                username: '',
                password: '',
                userType: '',
                verificationCode: ''
            },
            loginRules: {
                username: [{ required: true, message: "请输入用户名", trigger: "blur" }, { min: 11, message: "请输入正确的手机号", trigger: "blur" }],
                password: [{ required: true, message: "请填写密码", trigger: "blur" }],
                verificationCode: [{ required: true, message: "请填写验证码", trigger: "blur" }]
            },

            // 忘记密码相关
            forgetPasswordDialog: false,
            modifyForm: {
                phone: "",
                password: "",
                confirmPassword: "",
                phoneMessageCode: "",
                userType: "",
            },
            modifyFormRules: {
                phone: [{ required: true, validator: accountPhone, trigger: "change" }],
                password: [{ required: true, validator: modifyPassword, trigger: "blur" }],
                confirmPassword: [{ required: true, validator: modifyCheckPass, trigger: "blur" }],
                phoneMessageCode: [{ required: true, message: "请输入手机验证码", trigger: "blur" }]
            },
            modifyCount: 60,
            modifyDisabled: true,
            modifyCodeText: "获取验证码",
            submitForgetPasswordLoading: false,
            disabledType: "",
            userTypeStatus: 0,

            // 注册相关
            dialogProcess: false,
            accountForm: {
                phone: "",
                password: "",
                confirmPassword: "",
                phoneMessageCode: "",
            },
            accountFormRules: {
                phone: [{ required: true, validator: accountPhone, trigger: "change" }],
                password: [{ required: true, validator: accountPassword, trigger: "blur" }],
                confirmPassword: [{ required: true, validator: accountCheckPass, trigger: "blur" }],
                phoneMessageCode: [{ required: true, message: "请输入手机验证码", trigger: "blur" }],
                userType: [{ required: true, message: "请选择用户类型", trigger: "change" }]
            },
            accountDisabled: true,
            accountCodeText: "获取验证码",
            accountCount: 60,
            submitRegisterLoading: false,
            treatyChecked: false,
            options: [
                { value: '6', label: '个人' },
                { value: '7', label: '企业' }
            ]
        }
    },
    watch: {
        '$route': {
            handler: function(newV, oldV) {
                this.$data.isHomePage = newV.name === 'index';
                this.$refs['navBarCommonRef'].$el.style.position = this.$route.name === 'index' ? 'relative' : 'fixed';
            },
        }
    },
    created() {
        this.$data.isHomePage = this.$route.name === 'index';

        if (getToken()) {
            this.$data.isLogin = true;
            // this.$data.userName = JSON.parse(sessionStorage.getItem("userInfo")).realName;
            let userInfoObj = JSON.parse(window.sessionStorage.getItem("userInfo"));

            if (Object.keys(userInfoObj).length > 0) {
                const { realName, enterpriseName, userType, userName } = userInfoObj;
                if (userType == 7) {
                    this.$data.userName = enterpriseName ? enterpriseName : userName;
                } else {
                    this.$data.userName = realName ? realName : userName;
                }
            }
        }
    },
    mounted() {
        this.$refs['navBarCommonRef'].$el.style.position = this.$route.name === 'index' ? 'relative' : 'fixed';
    },
    methods: {
        onSubmit() {
            this.$refs["loginFormRef"].validate((valid) => {
                if (valid) {
                    http.post(api.login, this.$data.loginForm).then(data => {
                        if (data.code == "00000") {
                            this.$data.loginBox = false;
                            setToken(data.data.token);
                            setRefreshToken(data.data.refreshToken);

                            if (!isParamEmpty(getToken())) {
                                http.get(api.getUserInfo).then((response) => {
                                    this.$data.isLogin = true;
                                    this.$store.state.userInfo = response.data;
                                    this.$store.commit("SET_USER_INFO", { userInfo: response.data });
                                    setUserType(response.data.userType);
                                    setUserName(response.data.userName);
                                    setEnterpriseIsAuth(response.data.roleMenu);

                                    window.sessionStorage.setItem("userInfo", JSON.stringify(response.data));

                                    if (Object.keys(response.data).length > 0) {
                                        const { realName, enterpriseName, userType, userName } = response.data;
                                        if (userType == 7) {
                                            this.$data.userName = enterpriseName ? enterpriseName : userName;
                                        } else {
                                            this.$data.userName = realName ? realName : userName;
                                        }
                                    }
                                    if (this.$route.path === '/index') {
                                        this.$refs['routerViewRef'].$children[0].$children[0].$data.isLogin = false;
                                    }
                                });
                            }
                        } else {
                            this.switchLoginType(this.$data.loginForm['userType']);
                            this.$message.error(data.msg);
                        }
                    });
                }
            });
        },
        loginSelectType(userType, boolean) {
            http.get(api.apipath).then((data) => {
                this.$data.verificationCodeUrl = data.data.baseCode;
                this.$data.loginForm['uuid'] = data.data.uuid;
                this.$data.loginForm['userType'] = userType;
                if (!isParamEmpty(boolean) && boolean) {
                    this.$data.loginBox = true;
                }
            });
        },
        switchLoginType(userType) {
            this.$refs["loginFormRef"].resetFields();
            this.$data.loginForm['userType'] = userType;
            http.get(api.apipath).then((data) => {
                this.$data.verificationCodeUrl = data.data.baseCode;
                this.$data.loginForm['uuid'] = data.data.uuid;
            });
        },
        async handleCommand(val) {
            if (val === 'exitLogin') {
                http.get(api.quitLogin).then((data) => {
                    this.$store.dispatch('resetToken')
                    this.$data.isLogin = false;
                    if (this.$route.path === '/index') {
                        this.$refs['routerViewRef'].$children[0].$children[0].$data.isLogin = true;
                    }
                });
            } else {
                window.open(api.jump);
            }
        },

        // -------------------------- 修改密码 --------------------------
        modifyPassword() {
            this.disabledType = "MODIFY";
            this.forgetPasswordDialog = !this.forgetPasswordDialog;
            this.loginBox = false;
        },
        closeModifyForm(formName) {
            this.$refs["modifyForm"].resetFields();
            this.forgetPasswordDialog = !this.forgetPasswordDialog;
        },
        getModifyCode() {
            const that = this;

            countDown();

            that.$refs.modifyVerificationCode.focus();
            http.get(api.register + "/" + that.modifyForm.phone, that.modifyForm.phone).then((res) => {
                that.$message({
                    message: "验证码已发出，请查收！",
                    type: "success",
                });
            });

            function countDown() {
                if (that.modifyCount == 0) {
                    that.modifyDisabled = false;
                    that.modifyCodeText = "获取验证码";
                    that.modifyCount = 60;
                    return;
                } else {
                    that.modifyDisabled = true;
                    var count = that.modifyCount < 10 ? "0" + that.modifyCount : that.modifyCount;
                    that.modifyCodeText = "重新发送" + "(" + count + ")";
                    that.modifyCount--;
                }
                setTimeout(function () {
                    countDown();
                }, 1000);
            }
        },
        submitModifyForm(formName) {
            var that = this;
            that.$refs[formName].validate((valid) => {
                if (valid) {
                    that.submitForgetPasswordLoading = true;

                    that.modifyForm.userType = that.$data.loginForm['userType'];
                    switch (that.$data.loginForm['userType']) {
                        case "4":
                            http.post(api.forgetPassword, that.modifyForm).then((res) => {
                                if (res.code == "00000") {
                                    that.forgetPasswordDialog = !that.forgetPasswordDialog;
                                    that.$message({
                                        message: "修改成功",
                                        type: "success",
                                    });
                                } else {
                                    that.$message.error(res.msg);
                                }
                                that.submitForgetPasswordLoading = false;
                            }).catch((error) => {
                                that.submitForgetPasswordLoading = false;
                            });
                            break;
                        default:
                            http.post(api.forgetPassWordOther, that.modifyForm).then((res) => {
                                if (res.code == "00000") {
                                    that.submitForgetPasswordLoading = false;
                                    that.forgetPasswordDialog = !that.forgetPasswordDialog;
                                    that.$message({
                                        message: "修改成功",
                                        type: "success",
                                    });
                                } else {
                                    that.$message.error(res.msg);
                                }
                            }).catch((error) => {
                                that.submitForgetPasswordLoading = false;
                            });
                            break;
                    }
                } else {
                    return false;
                }
            });
        },
        // -------------------------- 修改密码 --------------------------

        // -------------------------- 账号注册 --------------------------
        registerAccont() {
            this.dialogProcess = true;
            this.loginBox = false;
        },
        getAccountCode() {
            const that = this;

            countDown();

            that.$refs.registerVerificationCode.focus();
            http
                .get(
                    api.register + "/" + that.accountForm.phone,
                    that.accountForm.phone
                )
                .then((res) => {
                    that.$message({
                        message: "验证码已发出，请查收！",
                        type: "success",
                    });
                });

            function countDown() {
                if (that.accountCount == 0) {
                    that.accountDisabled = false;
                    that.accountCodeText = "获取验证码";
                    that.accountCount = 60;
                    return;
                } else {
                    that.accountDisabled = true;
                    var count =
                        that.accountCount < 10
                            ? "0" + that.accountCount
                            : that.accountCount;
                    that.accountCodeText = "重新发送" + "(" + count + ")";
                    that.accountCount--;
                }
                setTimeout(function () {
                    countDown();
                }, 1000);
            }
        },
        /*
         * 关闭注册-按钮
         * */
        closeProcessForm(formName) {
            this.$refs[formName].resetFields();
            this.treatyChecked = false;
            this.dialogProcess = !this.dialogProcess;
        },
        /*
         * 提交注册
         * */
        submitProcessForm(formName) {
            var that = this;
            that.$refs[formName].validate((valid) => {
                if (valid) {
                    if (that.treatyChecked == false) {
                        that.$message({
                            showClose: true,
                            message: "请仔细阅读使用协议后，勾选已阅读",
                            type: "warning",
                        });
                        return;
                    }

                    that.submitRegisterLoading = true;

                    /* 这里是提交方法 */
                    http
                        .post(api.register, that.accountForm)
                        .then((response) => {
                            if (response.code == "00000") {
                                that.submitRegisterLoading = false;
                                that.$message({
                                    showClose: true,
                                    message: "注册" + response.msg || "注册成功",
                                    type: "success",
                                });
                                that.closeProcessForm("accountForm");
                            } else {
                                that.$message({
                                    showClose: true,
                                    message: response.msg,
                                    type: "warning",
                                });
                                that.dialogProcess = false;
                            }
                        })
                        .catch((error) => {
                            that.submitRegisterLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },

        // -------------------------- 账号注册 --------------------------
    }
};
</script>

<style lang="scss" scoped>
$unit: px;

@function convertPixel($pixel) {
    @return ($pixel * 0.75)+$unit
}
.gateway-container {
    font-size: 14px;

    .home-banner {
        height: convertPixel(235);
        background-color: red;
        background: url("./../assets/indexPage/home/home-banner.png") center center no-repeat;
        background-size: 100% 100%;

        .container {
            position: relative;
        }

        .el-image {
            position: absolute;
            top: convertPixel(30);
            width: convertPixel(199);
            height: convertPixel(63);
        }
    }

    .registerTitle {
        text-align: center;
        padding-top: 20px;
        color: #fff;
        font-size: 20px;
        font-weight: bold;
    }

    .registerTitle-ZC {
        text-align: center;
        color: #fff;
        font-size: 20px;
        font-weight: bold;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue